import React, { ReactElement } from "react";
import { Tabs, Tab } from "@mui/material";
import cssExports from "theme/styles/main.module.scss";

interface TabTopProps {
  tabKey: string;
  value: number;
  onChange: (event: React.SyntheticEvent, newValue: number) => void;
  tabs: TabTopItem[];
  visibleScrollbar?: boolean;
}

interface TabTopItem {
  text: ReactElement | string;
  onClickHandler?: () => void;
}

const TabTop: React.FC<TabTopProps> = (props) => {
  const a11yProps = (index: any) => {
    return {
      id: `${props.tabKey}-${index}`,
      "aria-controls": `${props.tabKey}-${index}`,
    };
  };

  React.useEffect(() => {
    const onClickHandler = props.tabs[props.value].onClickHandler;
    if (onClickHandler) onClickHandler();
  }, [props.value]);

  return (
    <div style={{ width: "100%" }}>
      <Tabs
        value={props.value}
        onChange={props.onChange}
        aria-label={props.tabKey}
        className={cssExports.tabs}
        visibleScrollbar={props.visibleScrollbar}
        variant={props.visibleScrollbar ? "scrollable" : "standard"}
        scrollButtons={false}
        classes={{ indicator: cssExports.tabIndicator, flexContainer: cssExports.tabFlexContainer }}
      >
        {props.tabs.map((tabText, index) => {
          return (
            <Tab
              key={index}
              label={tabText.text}
              {...a11yProps(index)}
              className={cssExports.tab}
              classes={{
                selected: cssExports.tabSelected,
                root: cssExports.tabWrapper,
              }}
            />
          );
        })}
      </Tabs>
    </div>
  );
};

export default TabTop;
